import { Show } from "solid-js";
import { UnionPatcher } from "../../patcher/patch-types";
import { createID } from "../../patcher/utils/html";

export default function (patcher: UnionPatcher) {
  const [selected, setSelected] = patcher.selected;

  return (
    <div class="patch-union mt-2">
      <span class="patch-union-title">{patcher.name}</span>
      <Show when={patcher.tooltip}>
        <div class="badge tip text-bg-secondary" innerHTML={patcher.tooltip}></div>
      </Show>
      <Show when={patcher.danger}>
        <div class="badge tip text-bg-danger" innerHTML={patcher.danger}></div>
      </Show>

      {
        patcher.patches.map((v, i) => {
          const id = createID();
          return (
            <div class="patch form-check">
              <input type="radio" id={id} name={patcher.id} class="form-check-input" checked={i === selected()} onclick={() => setSelected(i)} />
              <label for={id}>{v.name}</label>
              <Show when={v.tooltip}>
                <div class="badge tip text-bg-secondary" innerHTML={v.tooltip}></div>
              </Show>
              <Show when={v.danger}>
                <div class="badge tip text-bg-danger" innerHTML={v.danger}></div>
              </Show>
            </div>
          )
        })
      }
    </div>
  );
}
